export const i18n = {
    ja: {
        'nav.showroom': 'ショールーム',
        'nav.cars': '車両一覧',
        'nav.about': '会社情報',
        'nav.contact': 'お問い合わせ',
        'hero.title': '最先端バーチャル体験で、中古車の「安心」を可視化する。',
        'hero.lead': '高品質な中古車を360°バーチャルギャラリーで確認できます。塗装状態やインテリア等の詳細を確認し、どこにいても信頼できる購買体験を実現します。',
        'hero.ctaShowroom': '360°バーチャルギャラリーを見る',
        'hero.ctaInventory': '車両一覧へ',
        'trust.cert': '第三者レポート',
        'trust.global': '多数の輸出実績',
        'trust.secure': '安全なトレーサビリティ',
        'showroom.title': '360°バーチャルギャラリーの体験',
        'showroom.desc': '実際の展示場を高解像度スキャンし自由に移動できます。全体俯瞰で気になる車をピックアップすることができます。',
        'showroom.launch': '360°バーチャルギャラリーを見る',
        'showroom.f1': '自由視点',
        'showroom.f2': '高精細',
        'showroom.f3': '豊富な車両展示',
        'showroom.f4': '損傷スポット確認',
        'cars.title': '車両一覧',
        'about.title': '会社情報',
        'about.missionTitle': 'ミッション',
        'about.mission': '高品質な日本の中古車を全世界へ。距離と不安をテクノロジーで解消。',
        'about.globalTitle': 'グローバル展開',
        'about.global': '全世界へ輸出。地域ニーズに最適化します。',
        'about.contactTitle': '連絡先',
        'about.addrLabel': '所在地',
        'about.addr': '広島県広島市安佐南区八木2-16-22',
        'about.mailLabel': 'メール',
        'about.telLabel': 'TEL',
        'about.companyLabel': '会社名',
        'about.companyName': '有限会社 インパクト',
        'about.hoursLabel': '営業時間',
        'about.hours': '10：00〜19：00（定休日：火曜日）',
        'contact.title': 'お問い合わせ / ご相談',
        'contact.desc': '在庫確認・輸出手続き・追加検査などお気軽にご相談ください。',
        'contact.name': 'お名前',
        'contact.email': 'メールアドレス',
        'contact.message': 'お問い合わせ内容',
        'contact.submit': '送信',
        'contact.status.required': '必須項目を入力してください。',
        'contact.status.verifying': 'セキュリティ確認中...',
        'contact.status.verifyFailed': 'セキュリティ検証に失敗しました。少し待って再試行してください。',
        'contact.status.sending': '送信中...',
        'contact.status.sent': '送信しました。担当者から連絡します。',
        'contact.status.failed': '送信に失敗しました。時間をおいて再試行してください。',
        'footer.copy': '© 2025 有限会社インパクト. All rights reserved.',
        'footer.quick': 'クイックリンク',
        'footer.policy': 'ポリシー',
        'footer.terms': '利用規約',
        'footer.privacy': 'プライバシー',
        'footer.lang': '言語 / Language'
    },
    en: {
        'nav.showroom': 'Showroom',
        'nav.cars': 'Inventory',
        'nav.about': 'Company',
        'nav.contact': 'Contact',
        'hero.title': 'Visualizing Used Car "Trust" with Cutting-Edge Virtual Experience.',
        'hero.lead': 'Inspect high-quality used cars in a 360° virtual gallery. Check details such as paint condition and interior, providing a reliable purchasing experience from anywhere.',
        'hero.ctaShowroom': 'View 360° Virtual Gallery Showroom',
        'hero.ctaInventory': 'Browse Inventory',
        'trust.cert': 'Third-party Inspection',
        'trust.global': 'Exports to 120+ Countries',
        'trust.secure': 'Secure Traceability',
        'showroom.title': '360° Virtual Gallery Experience',
        'showroom.desc': 'Explore a high-resolution scan of the actual showroom. Pick up cars of interest from an overall perspective.',
        'showroom.launch': 'View 360° Virtual Gallery Showroom',
        'showroom.f1': 'Free View',
        'showroom.f2': 'High Fidelity Textures',
        'showroom.f3': 'Extensive Vehicle Display',
        'showroom.f4': 'Damage Spot Inspection',
        'cars.title': 'Vehicle Inventory',
        'about.title': 'Company Information',
        'about.missionTitle': 'Mission',
        'about.mission': 'Delivering high-quality Japanese used cars worldwide. Bridging distance and uncertainty with technology.',
        'about.globalTitle': 'Global Presence',
        'about.global': 'Exporting worldwide, tailored to regional needs.',
        'about.contactTitle': 'Contact',
        'about.addrLabel': 'Address',
        'about.addr': '2-16-22 Yagi, Asaminami-ku, Hiroshima City, Hiroshima Prefecture, Japan',
        'about.mailLabel': 'Email',
        'about.telLabel': 'TEL',
        'about.companyLabel': 'Company',
        'about.companyName': 'Impact Co., Ltd.',
        'about.hoursLabel': 'Business Hours',
        'about.hours': '10:00 AM - 7:00 PM (Closed on Tuesdays)',
        'contact.title': 'Inquiries / Consultation',
        'contact.desc': 'Feel free to contact us for stock confirmation, export procedures, additional inspections, and more.',
        'contact.name': 'Name',
        'contact.email': 'Email',
        'contact.message': 'Message',
        'contact.submit': 'Send',
        'contact.status.required': 'Please fill required fields.',
        'contact.status.verifying': 'Verifying security...',
        'contact.status.verifyFailed': 'Security verification failed. Please try again shortly.',
        'contact.status.sending': 'Sending...',
        'contact.status.sent': 'Submitted. We will respond soon.',
        'contact.status.failed': 'Submission failed. Please try again later.',
        'footer.copy': '© 2025 Impact Co., Ltd. All rights reserved.',
        'footer.quick': 'Quick Links',
        'footer.policy': 'Policy',
        'footer.terms': 'Terms of Use',
        'footer.privacy': 'Privacy',
        'footer.lang': 'Language / 言語'
    }
};
export function translate(key, lang) {
    return i18n[lang][key] ?? key;
}
